/**
 * #4/#1 — CANLI gelen-kutusu akışı (SSE), paylaşılan hook. Notification servisine tek
 * uzun-ömürlü EventSource açar; kutu değişince (`event: inbox`) geri çağırım tetiklenir
 * (çağıran unread-count + inbox sorgularını invalidate eder — polling yerine anlık).
 *
 * Tüm SPA'lar paylaşır (student/admin/teacher); tek fark Notification taban URL'idir → parametre.
 * AUTH: EventSource header gönderemez → access token query'de gider (BE yalnız /stream'de query
 * token kabul eder). Hata'da taze token'la yeniden bağlanır; token yoksa bağlanmaz; unmount'ta kapanır.
 */
import { useEffect, useRef } from 'react';

import { getAccessToken } from './sessionStore';

const RECONNECT_MS = 5000;

export function useInboxStream(notificationBaseUrl: string, onInboxChanged: () => void): void {
  const callback = useRef(onInboxChanged);
  useEffect(() => {
    callback.current = onInboxChanged;
  });

  useEffect(() => {
    let source: EventSource | null = null;
    let closed = false;
    let retryTimer: ReturnType<typeof setTimeout> | undefined;

    const connect = () => {
      const token = getAccessToken();
      if (!token || closed) return;

      source = new EventSource(`${notificationBaseUrl}/api/v1/notifications/stream?access_token=${encodeURIComponent(token)}`);
      source.addEventListener('inbox', () => callback.current());
      source.onerror = () => {
        // EventSource kendi retry'ını ESKİ token'la yapardı; kapatıp taze token'la yeniden bağlan.
        source?.close();
        source = null;
        if (!closed) retryTimer = setTimeout(connect, RECONNECT_MS);
      };
    };

    connect();
    return () => {
      closed = true;
      if (retryTimer) clearTimeout(retryTimer);
      source?.close();
    };
  }, [notificationBaseUrl]);
}
